import { render, staticRenderFns } from "./agentLevelChangeHistory.vue?vue&type=template&id=ec867ad6&scoped=true"
import script from "./agentLevelChangeHistory.vue?vue&type=script&lang=js"
export * from "./agentLevelChangeHistory.vue?vue&type=script&lang=js"
import style0 from "./agentLevelChangeHistory.vue?vue&type=style&index=0&id=ec867ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec867ad6",
  null
  
)

export default component.exports